import React, { useState } from "react";
import { Dialog, DialogContent, Grid, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import DialogTitle from "../DialogTitle/DialogTitle";

interface State {
  open: boolean;
}

const EmployeeCostReportGuide = () => {
  const theme = useTheme();
  const [state, setState] = useState<State>({
    open: false,
  });

  return (
    <>
      <IconButton onClick={() => setState((state) => ({ ...state, open: true }))}>
        <FontAwesomeIcon
          icon={faInfoCircle}
          color={theme.palette.primary.main}
        />
      </IconButton>
      <Dialog
        open={state.open}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          title={"Employee cost section info"}
          handleClose={() => setState((state) => ({ ...state, open: false }))}
        />
        <DialogContent>
          <Grid>
            <Grid>
              <Typography variant="h6">
                <b>How can I add a new section ?</b>
              </Typography>
              <Typography>
                The different sections are automatically loaded according to the legislation of the selected legal
                entity. They are maintained through the system table : <b>Legislation employee cost sections</b>
              </Typography>
            </Grid>
            <br />
            <br />
            <Grid>
              <Typography variant="h6">
                <b>How are sections calculated ?</b>
              </Typography>
              <Typography>
                There are three ways of updating the section amount :
                <br />
                <br />
                <Grid>
                  <Typography>
                    {" "}
                    1. By the total of the contributing sections to it (either by adding or substracting)
                  </Typography>
                  <Typography> 2. By its proportionality to another section </Typography>
                  <Typography> 3. By manual updating</Typography>
                </Grid>
                <br />
                <br />
                You can find out the different contributing sections to a particular one by clicking on its amount.{" "}
                <br />
                You can also find out to what section the current one contributes to by clicking on its name.
                <br />
                To find out to what section the current one is proportional to , hover on it's rate.
                <br />
                Some sections have a predefined rate and a manual input for the amount. The rate here is simply
                informative and automatically calculated based on the entered amount
              </Typography>
            </Grid>
            <br />
            <br />
            <Grid>
              <Typography variant="h6">
                <b>How can I update social security section rate ?</b>
              </Typography>
              <Typography>
                The social security cost sections are configured from the system table :{" "}
                <b> Legislation social security cost sections .</b>
              </Typography>
            </Grid>
            <br />
            <br />
            <Grid>
              <Typography variant="h6">
                <b>
                  What happens if the system configuration has changed after I save a Proforma employee cost report ?
                </b>
              </Typography>
              <Typography variant="body1">
                <b>View mode : </b>
              </Typography>
              <Typography>
                If the report is in view mode (when it is already accepted by the client), nothing will show up, only
                the saved amounts and rates. No hints will appear since when a report is sent to the client, it should
                not be modified anymore
              </Typography>
              <br />
              <b>Editing mode : </b>
              <Typography>
                If the proportional to or contributing section configuration changes, the system does not keep a copy of
                the previous configuration. Thus the amounts will be automatically recalculated when editing the report
                with a hint about the previous amounts. The previous amounts will disappear upon any changes made to the
                report.
              </Typography>
              <Typography>
                If the section rate has changed, the system will display the rate used when report was saved , but give
                the user the option to update accodring to the system newly configured rate. The previous amounts will
                disappear upon any changes made to the report.
              </Typography>
              These changes should be rare however It may happen that some rates change over the time
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default EmployeeCostReportGuide;
